import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-sidepanel-acitivity',
  templateUrl: './common-sidepanel-acitivity.component.html',
  styleUrls: ['./common-sidepanel-acitivity.component.css']
})
export class CommonSidepanelAcitivityComponent implements OnInit {

  tabActive = "";
  @Input() userId!: number;
  @Input() carrierId: number;
  constructor() { }

  ngOnInit(): void {
  }

  getSelectedTab(event){
    this.tabActive = event.srcElement.hash != undefined? event.srcElement.hash : this.tabActive;
  }

}
